import { useSelector } from 'react-redux';
import { RootState } from '../../../../store';
import { UserInstrument } from '../../../../#interfaces/interfaces';
import {
    Box, Chip, Dialog, DialogContent, DialogTitle, IconButton, Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const BG_SECTION     = '#1c1c24';
const BRAND_RED      = '#c0392b';
const TEXT_PRIMARY   = '#f4f4f6';
const TEXT_SECONDARY = 'rgba(244,244,246,0.65)';
const BORDER_SUBTLE  = '1px solid rgba(255,255,255,0.08)';

interface UserInstrumentsModalProps {
    userNickname: string;
    onClose: (v: boolean) => void;
}

export default function UserInstrumentsModal({ userNickname, onClose }: UserInstrumentsModalProps) {
    const userInstruments = useSelector((state: RootState) => state.sessionProfile.userInstruments);
    const selected = userInstruments.filter((u: UserInstrument) => u.selected !== false);

    return (
        <Dialog
            open
            onClose={() => onClose(false)}
            fullWidth
            maxWidth='xs'
            PaperProps={{
                sx: {
                    bgcolor: BG_SECTION,
                    border: BORDER_SUBTLE,
                    borderRadius: '12px',
                    color: TEXT_PRIMARY,
                },
            }}
        >
            <DialogTitle sx={{
                display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                pb: 1, borderBottom: BORDER_SUBTLE,
            }}>
                <Box>
                    <Typography variant='h6' fontWeight={700} color={TEXT_PRIMARY}>Instruments</Typography>
                    <Box sx={{ width: 32, height: 3, bgcolor: BRAND_RED, mt: 0.5 }} />
                </Box>
                <IconButton onClick={() => onClose(false)} size='small' sx={{ color: TEXT_SECONDARY, '&:hover': { color: TEXT_PRIMARY } }}>
                    <CloseIcon fontSize='small' />
                </IconButton>
            </DialogTitle>

            <DialogContent sx={{ pt: 2 }}>
                {selected.length === 0 ? (
                    <Typography variant='body2' color={TEXT_SECONDARY} textAlign='center' py={3}>
                        No instruments added yet.
                    </Typography>
                ) : (
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                        {selected.map((item: UserInstrument, i: number) => (
                            <Chip
                                key={i}
                                label={item.instrument.name}
                                size='small'
                                sx={{
                                    bgcolor: 'rgba(192,57,43,0.15)',
                                    color: TEXT_PRIMARY,
                                    border: `1px solid ${BRAND_RED}`,
                                    fontWeight: 500,
                                }}
                            />
                        ))}
                    </Box>
                )}
            </DialogContent>
        </Dialog>
    );
}
